export class GruppeBewegung {
    gruppe_id: number;
    anzahl_tiere: number;
    datum: Date;
    abteil: string;
    mail_entsorger: number;
    todesart_id: number;
    bewegung_typ: number;
    ausstallgewicht: number;
    einstallgewicht: number;
    futtermenge: number;
    gruppe_id_ziel: number;
    einstallen_buchen: number;
    an_hit_melden: number;
}
